export default {
  email: [
    {
      key: "required",
      message: "Mejladress är obligatoriskt.",
      id: "emailRequired",
    },
    {
      key: "emailFormat",
      message: "Felaktigt format på mejladressen.",
      id: "emailFormat",
    },
  ],
};
